
// shop tab start

$(document).ready(function () {
    $('.shop-collection__tab-item').on('click', function () {
        $('.shop-collection__tab-item').removeClass('active');
        $(this).addClass('active');
    });
});

// shop tab end

// scroll-animation start


document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".scroll-animation");

    function checkScroll() {
        elements.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.85) {
                element.classList.add("visible");
            }
        });
    }

    window.addEventListener("scroll", checkScroll);
    checkScroll(); // Run on load in case elements are already in view
});


// scroll-animation end




// marquee start


$(".marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});



// marquee end





// explore start



if ($(Window).width() < 768) {
    $('.explore__items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}







// explore end




// reviews start




$('.reviews__item').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    infinite: true,
});

let scrollThrottle = false;
$('.reviews__item').on('wheel', function (e) {
    e.preventDefault();
    if (scrollThrottle) return;
    scrollThrottle = true;
    setTimeout(() => (scrollThrottle = false), 700);
    $(this).slick(e.originalEvent.deltaY < 0 ? 'slickPrev' : 'slickNext');
});

document.addEventListener('DOMContentLoaded', () => {
    const resetAll = () => {
        document.querySelectorAll('.reviews__item-card').forEach(card => {
            const v = card.querySelector('video');
            card.querySelector('.reviews__video-icon-play').style.display = 'block';
            card.querySelector('.reviews__video-icon-pause').style.display = 'none';
            card.querySelector('.reviews__video-sound-mute').style.display = 'block';
            card.querySelector('.reviews__video-sound-un-mute').style.display = 'none';
            v.pause();
            v.muted = true;
        });
    };

    document.querySelectorAll('.reviews__item-card').forEach(card => {
        const video = card.querySelector('video');
        const play = card.querySelector('.reviews__video-icon-play');
        const pause = card.querySelector('.reviews__video-icon-pause');
        const mute = card.querySelector('.reviews__video-sound-mute');
        const unmute = card.querySelector('.reviews__video-sound-un-mute');

        // Init state
        play.style.display = video.paused ? 'block' : 'none';
        pause.style.display = video.paused ? 'none' : 'block';
        mute.style.display = video.muted ? 'block' : 'none';
        unmute.style.display = video.muted ? 'none' : 'block';

        play.onclick = () => {
            resetAll();
            video.muted = false;
            video.play();
            play.style.display = 'none';
            pause.style.display = 'block';
            mute.style.display = 'none';
            unmute.style.display = 'block';
        };

        pause.onclick = () => {
            video.pause();
            play.style.display = 'block';
            pause.style.display = 'none';
            mute.style.display = 'block';
            unmute.style.display = 'none';
        };

        mute.onclick = () => {
            video.muted = false;
            mute.style.display = 'none';
            unmute.style.display = 'block';
        };

        unmute.onclick = () => {
            video.muted = true;
            mute.style.display = 'block';
            unmute.style.display = 'none';
        };
    });
});









// reviews end

// Mobile menu open
$(".header__mobi-menu").on('click', function () {
    $("body").addClass('menu-open');
})
$(".menu-close , .overlay").on('click', function (e) {
    e.preventDefault();
    $("body").removeClass('menu-open');
});

// cart-drawer start


$(".header__cart").on('click', function () {
    $("body").addClass('cart-open');
})
$(".cart-drawer__top-close , .overlay").on('click', function (e) {
    e.preventDefault();
    $("body").removeClass('cart-open');
});

$(document).on("click",".cart-drawer-empty-btn-shop",function(e) {
    e.preventDefault();
    $("body").removeClass('cart-open');
    });



// cart-drawer end



// if ($(Window).width() > 768) {
//     var rellax = new Rellax('.rellax');
// }



// main-product start


$('.main-product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    dots:false,
    // asNavFor: '.main-product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                 dots:false,
            }
        },
    ]
});
/*
$('.main-product__small-items').slick({
    slidesToShow: 9,
    slidesToScroll: 9,
    asNavFor: '.main-product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});
*/
$('.main-product__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.main-product__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// main-product end
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
// Check if the 'cart' URL parameter is 'true' and open the cart drawer if so
$(document).ready(function() {
    if (getUrlParameter('cart') === 'true') {
        $('body').addClass('cart-open');
        $('.cart-drawer').addClass('open');
    }
});

// accordion start


$(".accordion__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__content").slideUp();
    } else {
        $(".accordion__content").slideUp();
        $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__content").slideDown();
    }
})



// accordion end

// why start



if (window.matchMedia("(min-width: 1024px)").matches) {
    const itemsContainer = document.querySelector('.why__items');
    const items = Array.from(itemsContainer.children);

    const half = Math.ceil(items.length / 2);

    const reordered = [];

    for (let i = 0; i < half; i++) {
        if (items[i]) reordered.push(items[i]);               // Left column
        if (items[i + half]) reordered.push(items[i + half]); // Right column
    }

    // Replace content with reordered items
    itemsContainer.innerHTML = '';
    reordered.forEach(item => itemsContainer.appendChild(item));
}



// why end




// homepage product-card slider start



$('.shop-range__items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});




// homepage product-card slider end







$(function () {
    $(".tabs__item").on("click", function () {
        const type = $(this).data("type");

        $(".tabs__item").removeClass("active");
        $(this).addClass("active");

        $(".shop-range__tab-content").removeClass("active")
            .filter(`[data-type="${type}"]`)
            .addClass("active");
    });
});

$('.shop-range__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.shop-range__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




